import * as Fingerprint2 from 'fingerprintjs2'

export class FingerprintService {
  static get() {
    return new Promise((resolve, reject) => {
      const getHash = async () => {
        const options = {
          excludes: {
            plugins: true,
            localStorage: true,
            adBlock: true,
            screenResolution: true,
            availableScreenResolution: true,
            enumerateDevices: true,
            pixelRatio: true,
            doNotTrack: true,
          },
        }

        try {
          const components = await Fingerprint2.getPromise(options)
          const values = components.map(({ value }) => value)

          return Fingerprint2.x64hash128(values.join(''), 31).toString()
        } catch (error) {
          reject(error)
        }
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(async () => resolve(await getHash()))
      } else {
        setTimeout(async () => resolve(await getHash()), 500)
      }
    })
  }
}
